"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ListView_1 = require("../ListView");
var SquareLayout = /** @class */ (function () {
    /**
     * @param maxWidth max width of item in pixels
     * @param sideMargin side margins of item in pixels
     * @param bottomMargin bottom margin of item in pixels
     */
    function SquareLayout(maxWidth, sideMargin, bottomMargin) {
        this.maxWidth = maxWidth;
        this.sideMargin = sideMargin;
        this.bottomMargin = bottomMargin;
        this.orientation = ListView_1.Orientation.Vertical;
    }
    SquareLayout.prototype.layout = function (photoList, viewportSize) {
        var itemWidth = this.maxWidth + this.sideMargin;
        var itemsInRow = Math.ceil(viewportSize.width / itemWidth);
        var extraWidth = viewportSize.width - this.sideMargin - itemWidth * itemsInRow;
        var width = this.maxWidth + Math.floor(extraWidth / itemsInRow);
        var height = width;
        var x = this.sideMargin, y = 0;
        var gridList = [{ width: width, height: height, x: x, y: y }];
        for (var index = 1; index < photoList.length; index++) {
            (index % itemsInRow)
                ? (x = x + width + this.sideMargin)
                : (x = this.sideMargin, y = y + height + this.bottomMargin);
            gridList.push({ width: width, height: height, x: x, y: y });
        }
        return gridList;
    };
    return SquareLayout;
}());
exports.SquareLayout = SquareLayout;
